import { render } from "./Snapshot.vue?vue&type=template&id=65967758&ts=true"
import script from "./Snapshot.vue?vue&type=script&lang=ts"
export * from "./Snapshot.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Build\\vsts-agent-win-x64-4.268.0\\_work\\2\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__